import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NoticiaService } from '../../services/noticia/noticia.service';
import { CarouselModule } from 'primeng/carousel';

@Component({
  selector: 'app-noticia',
  standalone: true,
  imports: [CommonModule, RouterModule, CarouselModule],
  templateUrl: './noticia.component.html',
  styleUrls: ['./noticia.component.scss'],
})
export class NoticiaComponent implements OnInit {
  currentPage: number = 1;
  itemsPerPage: number = 6;
  totalPages: number = 1;
  paginatedItems: any[] = [];
  showMore: boolean = false;
  aparecerNoticia: boolean = true;
  items: any[] = [];
  
  responsiveOptions = [
    {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 3
    },
    {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 2
    },
    {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1
    }
];

  constructor(private router: Router, private noticiaService: NoticiaService) {}

  ngOnInit(): void {
    this.getNoticias();
  }

  removerTagsHtml(text: string): string {
    if (!text) {
      return '';
    }
    const doc = new DOMParser().parseFromString(text, 'text/html');
    return doc.body.textContent || "";
  }
  
  getNoticias() {
    this.noticiaService.getNoticias().subscribe(
      (res) => {
        console.log('Resposta da API:', res);
        console.log('Formato Arquivos:', res.formatoArquivos);

        if(res.formatoArquivos.length == 0) {
          this.aparecerNoticia = false
        }

        this.items = res.formatoArquivos.map((noticia: any) => ({
          titulo: noticia.nomePublicacao,
          imagem: noticia.binPublicacao ? noticia.binPublicacao : '',
          subtitulo: this.removerTagsHtml(noticia.dscPublicacao) || '',
          urlBin: noticia.urlBin,
          data: this.formatDate(noticia.datPublicacao),
        }));        
        
        this.totalPages = Math.ceil(this.items.length / this.itemsPerPage);
        console.log('Total de Páginas:', this.totalPages);

        this.updatePaginatedItems();

        if (this.items.length > this.itemsPerPage) {
          this.showMore = true;
        } else {
          this.showMore = false;
        }
      },
      (error) => {
        console.error('Erro ao buscar noticias:', error);
      }
    );
  }

  formatDate(dateString: string): string {
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  }

  loadMoreNews() {
    this.itemsPerPage += 6;
    this.updatePaginatedItems();

    if (this.itemsPerPage >= this.items.length) {
      this.showMore = false;
    }
  }

  showLessNews() {
    this.itemsPerPage = 6;
    this.updatePaginatedItems();
    this.showMore = true;
  }

  updatePaginatedItems() {
    this.paginatedItems = this.items.slice(0, this.itemsPerPage);
  }
}
